 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		60: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "js/" + ({"0":"lang-pl","1":"lang-en"}[chunkId]||chunkId) + "." + {"0":"ce637e369a3285c0dc76","1":"5777eda08363c9f1a0a3","2":"5234accd984dfbf3eb29","3":"243fb9c907dd0633c4a8","4":"ccd9f050bccdc7d95d42","5":"9d06b09a1a50a7799c11","6":"8ea0d94944d5f779648d","7":"0b37124517a927ccb65c","8":"49b342c25a03983b8878","9":"f3a52735a17f05a23942","10":"9301790ee20b81bb66d8","11":"6508ecaa12d4473fc664","12":"831bfef9a75c2bdc096f","13":"701fd792995d44327ffd","14":"d14b0c6f123307d8b9f0","15":"4689bd6f33ac370a90dc","16":"f155863b71dbd19e0112","17":"b421753a41bdadc7588c","18":"ac2300a971fa57dd568e","19":"2dd606386c7e3df599e5","20":"556f9d9852b594294688","21":"fb2560bd3d593e4e7ecb","22":"abaa93168580c292c538","23":"913d897a4847fc6c1fae","24":"a2e726c09f7de600fb7f","25":"0374643c53821cae2f5a","26":"cb4a8388f372fe603c8a","27":"143b855d81871a715be8","28":"46a6e05ccd488d1505f5","29":"08ed9fdcfb85cd0e691b","30":"70eab2fc78c12a393684","31":"6c082933efd5ac9acbf0","32":"c0796876c737dd9b8b1f","33":"f808200ad90ae65a9b0c","34":"e39459492860cfd93221","35":"d25272bdaa8ffbcacff7","36":"e23a707af2252a1a9afe","37":"b84a590a8dbc570c6ccb","38":"c0cad01b8988a09ba6bd","39":"19a2566fc7db3d2222ee","40":"d54c2f9d94e8c24aff7a","41":"d7396c8e5afcae1b7ef1","42":"5ed0d79b77531d68a6cc","43":"52f4ac3336df2781d8b3","44":"078ff01d54c077ded8aa","45":"c339135a0b44dfec3a50","46":"51ad111b025317b1b006","47":"04f198057d393771f2a7","48":"f26e82763adbbc0ae355","49":"b3d3d22b1d7153045b2c","50":"fdb71f9b08dbeeaa3329","51":"fc5d9e8d0da50a949c4e","52":"b5c927b93901786c62fd","53":"0a58db8126279abdca15","54":"087a31dfa6428165693c","55":"6f6cb9dd1c6d8c866910","56":"89a39da0a7214d86d6ff","57":"d9e84421a3ef4c401a85"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 8874d9fcce56aadda13a